//
// takes a promise and request, success, and failure types to build out a basic action creator
//
export default function multiWithPromiseMiddleware() {
  return ({ dispatch, getState }) => {
    return next => action => {
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      const { promise, types, description, ...rest } = action; // eslint-disable-line no-redeclare
      if (!promise) {
        return next(action);
      }

      const [REQUEST, SUCCESS, FAILURE] = types;
      next({ payload: rest, type: REQUEST });

      const actionPromise = promise(getState);
      actionPromise.then(
        (result) => next({ payload: { ...rest, result: result }, type: SUCCESS }),
        (error) => {
          let errorMessage = `Could not ${description}`;
          if (error) {
            errorMessage = `${errorMessage}: ${error}`;
          }
          return next({ payload: { ...rest, message: errorMessage }, type: FAILURE });
        }
      ).catch((error) => {
        console.error('MIDDLEWARE ERROR:', error);
        next({ payload: { ...rest, message: error }, type: FAILURE });
      });

      return actionPromise;
    };
  };
}


// WEBPACK FOOTER //
// ./src/redux/middleware/multiWithPromiseMiddleware.js